import React from "react";
import { handleApiErrors } from './api-errors'
import moment from 'moment-timezone';
const tz = 'Asia/Ho_Chi_Minh';
import AppConfig from '../config/app'
import { storedb } from '../views/client/storedb'

export const HasPermission = (permission) => {
  const rolePermissions = storedb().getPermissionsRoles()
  if (!rolePermissions || rolePermissions.length == 0) {
    return false
  }
  if (permission && permission != '') {
    return rolePermissions.indexOf(permission) > -1 ? true : false;
  }
  return false
}
export const Uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export const formatDateTime = (inputValue, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!inputValue) {
    return moment().tz(tz).format(format);
  }

  if (typeof inputValue === 'string') {
    inputValue = moment(new Date(inputValue))
  }

  return inputValue.tz(tz).format(format);
}

export const parseDatetime = (inputValue, defaultIfNull) => {
  if (!inputValue) {
    if (!defaultIfNull) {
      return null
    }
    return moment().tz(tz);
  }

  if (typeof inputValue === 'string') {
    inputValue = moment(new Date(inputValue))
  }

  return inputValue.tz(tz);
}
export const GetKhachHangStatusValue = () => {
  return [AppConfig.KHACHHANG_MOI, AppConfig.KHACHHANG_DANGHOATDONG, AppConfig.KHACHHANG_DAHUY]
}
export const GetCanhBaoTonKho = () => {
  return {
    CANH_BAO_SO_LUONG: AppConfig.CANH_BAO_SO_LUONG
  }
}
export const getKhachHangStatusText = (status) => {
  let result = ''
  let className = ''
  let icon = ''
  switch (status) {
    case AppConfig.KHACHHANG_MOI:
      result = "Khách hàng mới, chờ phê duyệt"
      className = 'text-warning'
      icon = 'fa-clock-o'
      break;
    case AppConfig.KHACHHANG_DANGHOATDONG:
      result = "Khách hàng đang hoạt động"
      className = 'text-success'
      icon = 'fa-check'
      break;
    case AppConfig.KHACHHANG_DAHUY:
      result = "Khách hàng đã huỷ, tạm thời khoá"
      className = 'text-danger'
      icon = 'fa-lock'
      break;
    default:
      return ''
  }
  return {
    result: result,
    className: className,
    icon: icon
  }
}
export const getOrdetStatusText = (status, appendStyle = false) => {
  let result = ''
  let className = ''
  switch (status) {
    case AppConfig.ORDER_STATUS.Nhap:
      result = AppConfig.ORDER_STATUS.NhapText
      className = 'text-muted'
      break;
    case AppConfig.ORDER_STATUS.HoanThanhNhap:
      result = AppConfig.ORDER_STATUS.HoanThanhNhapText
      className = 'text-primary'
      break;
    case AppConfig.ORDER_STATUS.DangXuLy:
      result = AppConfig.ORDER_STATUS.DangXuLyText
      className = 'text-info'
      break;
    case AppConfig.ORDER_STATUS.HoanThanh:
      result = AppConfig.ORDER_STATUS.HoanThanhText
      className = 'text-success'
      break;
    case AppConfig.ORDER_STATUS.Huy:
      result = AppConfig.ORDER_STATUS.HuyText
      className = 'text-danger'
      break;
    default:
      return ''
  }

  if (appendStyle) {
    return (
      <b className={className}>{result}</b>
    )
  } else {
    return result
  }
}
// transfer object
export const transferFromCached = (dataCached) => {
  if (!dataCached) return {}
  if (!dataCached.table) return dataCached
  return dataCached.table
}

// transfer list objects
export const transfersFromCached = (datasCached) => {
  if (!datasCached) return []
  return datasCached.map((item) => {
    if (!item.table) return item
    return item.table
  })
}

export const currentDate = () => {
  return moment().tz(tz);
}

export const storeInfo = () => {
  let result = {};
  try {
    const storedToken = localStorage.getItem('token')
    if (storedToken && storedToken != 'undefined') {
      result = JSON.parse(storedToken)
    }
  } catch (error) {
    console.log(error);
  }

  return result;
}


export async function handleRequest(request) {
  const result = await request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => {
      const errStr = error.toString()
      if (errStr.indexOf('Request failed with status code 500') > -1) {
        throw 'Lỗi kết nối, xin hãy thử lại';
      }
      throw error;
    });

  return result;
}

export function sum(items, key) {
  return items.reduce((a, b) => a + (b[key] || 0), 0)
}

export const barCodeFirst = (input, digitLenght = 13) => {
  let str = `${input}`
  if (str.length >= digitLenght) return str;
  const leftInsert = digitLenght - str.length
  for (let i = 0; i < leftInsert; i++) {
    str = `0${str}`
  }
  return str
}
export const customSelectStyles = {
  control: base => ({
    ...base,
    height: 30,
    minHeight: 30,
    borderRadius: 0,
    border: "none"
  })
};
export const customSelectStylesMulti = {
  control: base => ({
    ...base,
    minHeight: 30,
    borderRadius: 0,
    border: "none"
  })
};
export const inputFileType = {
  INPUT: 1,
  CHECKBOX: 2,
  TEXTAREA: 3,
  IMAGE: 4,
};

export const queryEncoding = function (obj) {
  try {
    if (obj == null) return ""
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  } catch (error) {
    return obj
  }
}

export const DataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}
export const GetCurrentDayName = () => {
  var date = new Date();
  var current_day = date.getDay();
  var day_name = '';
  switch (current_day) {
    case 0:
      day_name = "Chủ nhật";
      break;
    case 1:
      day_name = "Thứ hai";
      break;
    case 2:
      day_name = "Thứ ba";
      break;
    case 3:
      day_name = "Thứ tư";
      break;
    case 4:
      day_name = "Thứ năm";
      break;
    case 5:
      day_name = "Thứ sáu";
      break;
    case 6:
      day_name = "Thứ bảy";
  }
  return day_name;
}


// WEBPACK FOOTER //
// ./src/lib/common.js